import React, { useMemo } from 'react';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import { snackbarHelperActions } from 'src/components/20-helper-views/snackbar/useSnackbar';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { useSubjectNotesListQuery } from 'src/modules/exam-preparation/graphql/subject/getNotesList';
import { useRemoveNoteFromSubjectMutation } from 'src/modules/exam-preparation/graphql/subject/removeNoteFromSubject';
import useI18n from 'src/modules/translations/hooks/useI18n';
import analytics from '../../analytics';
import AttachNoteDrawer from './components/AttachNoteDrawer';
const listAnalytics = analytics.setWidget('Notes').setTarget('NoteList');
export default function useData(subjectID) {
    const { translate } = useI18n();
    const [listQueryState, listQueryActions] = useSubjectNotesListQuery({
        listAnalytics,
    });
    const [removeMutationState, removeMutationActions] = useRemoveNoteFromSubjectMutation();
    const listQueryVariables = useMemo(() => ({ subjectID }), [subjectID]);
    const handleNotePress = useStableCallback(() => {
        analytics.setWidget('Notes_NoteList').setTarget('Note').click();
    });
    const handleAddNote = useStableCallback(() => {
        bottomDrawerHelperActions.show({
            component: React.createElement(AttachNoteDrawer, { subjectID }),
        });
    });
    const handleRemoveNote = useStableCallback((noteID) => {
        removeMutationActions.submit({
            variables: {
                subjectID,
                noteID,
            },
            onCompleted() {
                snackbarHelperActions.show({
                    variant: 'POSITIVE',
                    duration: 'SHORT',
                    message: translate('Note removed successfully'),
                });
            },
        });
    });
    const state = {
        listQuery: listQueryState,
        listQueryVariables,
        removeMutation: removeMutationState,
    };
    const actions = {
        listQuery: listQueryActions,
        handleNotePress,
        handleAddNote,
        handleRemoveNote,
    };
    return [state, actions];
}
